import React, { useState } from "react";
import { AppRouter } from "./routers/AppRouter.js";
import { GlobalContext } from "./context/globalContext";
import TagManager from "react-gtm-module";

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const bunoParam = urlParams.get("buno");
const bpsParam = urlParams.get("bps");
let GTM = bunoParam ? "GTM-528NJB2" : "GTM-PH7X3QQ";

if (!!bpsParam) {
  GTM = "GTM-5FSBX47";
}

const consent = localStorage.getItem("consent");
var dataLayer = [];



export const App = () => {
  const url = window.location.href;
  let brand = "bmw";
  if (url.indexOf("mini") > -1) {
    brand = "mini";
  }
  window.AEMCheckConsent(brand).then(function (done) {
    if (done.GoogleAnalytics === true) {
      const tagManagerArgs = {
        gtmId: GTM,
      };
      TagManager.initialize(tagManagerArgs);
    } else {
      var dataLayer = [];
    }
    if (done.ContentSquare === true) {
      (function () {
        var mt = document.createElement("script");
        mt.type = "text/javascript";
        mt.async = true;
        mt.src = "//t.contentsquare.net/uxa/213f1e844dc32.js";
        document.getElementsByTagName("head")[0].appendChild(mt);
      })();
    }
  });

  const [state, setState] = useState({
    form: "initial",
    inputValue: "",
    provinceValue: "",
    outlet: "",
    outletName: "",
    carSpecs: "",
    dealers: "",
    productsAvailable: "",
    step: 0,
    errorMessage: [],
    defaultLong: -3.703339,
    defaultLat: 40.416729,
    modal: false,
    carousel: "",
    brand: brand,
  });

  return (
    <GlobalContext.Provider
      value={{
        state,
        setState,
      }}>
      <AppRouter />
    </GlobalContext.Provider>
  );
};
